<template>
  <!-- eslint-disable vue/max-attributes-per-line vue/no-static-inline-styles -->
  <section class="ts-loader">
    <div class="card wavebg !tw-w-full">
      <div class="ts-loader__header">
        <div class="">
          <div class="">
            Traffic Sources
          </div>
        </div>
        <div class="ts-loader__controls-wrapper">
          <button class="btn btn-primary btn-sm">
            + New Traffic Source
          </button>
          <div
            class="empty-pagination tw-ml-8 mobile:tw-ml-0"
            style="width: 269px"
          >
            <div
              class="empty-select mr-8"
              style="width: 80px"
            >
              100
            </div>
            <span>&lt; &lt;&lt; Page</span>
            <div class="form-group mb-0 mt-0">
              <input
                placeholder="1"
                class="form-control mt-0 pl-16 pr-16"
                style="width: 40px"
              >
            </div>
            <span>of 2 > >></span>
          </div>
        </div>
      </div>

      <div class="table-empty mt-16 mb-8">
        <div class="table-empty__head">
          <!-- <div class="cell">Promocode</div>
            <div class="cell">Promocode</div>
            <div class="cell">Actions</div> -->
        </div>
        <div class="table-empty__body">
          <!-- <div class="table-empty__body-row">
              <div class="cell">Promocode</div>
              <div class="cell">!@#$%^&*){}/*++</div>
              <div class="cell text-red">Delete</div>
            </div>
            <div class="table-empty__body-row">
              <div class="cell">Promocode</div>
              <div class="cell">!@#$%^&*){}/*++</div>
              <div class="cell text-red">Delete</div>
            </div>
            <div class="table-empty__body-row">
              <div class="cell">Promocode</div>
              <div class="cell">!@#$%^&*){}/*++</div>
              <div class="cell text-red">Delete</div>
            </div>
            <div class="table-empty__body-row">
              <div class="cell">Promocode</div>
              <div class="cell">!@#$%^&*){}/*++</div>
              <div class="cell text-red">Delete</div>
            </div> -->
        </div>

        <div class="mob-table__block mob-table__block-actions pt-0">
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="mob-table__actions">
            <span class="text-green">Promocode</span>
            <span class="text-red">Promocode</span>
            <span class="text-green">Promocode</span>
          </div>
        </div>
        <div class="mob-table__block mob-table__block-actions">
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="mob-table__actions">
            <span class="text-green">Promocode</span>
            <span class="text-red">Promocode</span>
            <span class="text-green">Promocode</span>
          </div>
        </div>
        <div class="mob-table__block mob-table__block-actions">
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="mob-table__actions">
            <span class="text-green">Promocode</span>
            <span class="text-red">Promocode</span>
            <span class="text-green">Promocode</span>
          </div>
        </div>
        <div class="mob-table__block mob-table__block-actions">
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="table-empty__row !tw-justify-between">
            <span>Promocode</span>
            <span>0</span>
          </div>
          <div class="mob-table__actions">
            <span class="text-green">Promocode</span>
            <span class="text-red">Promocode</span>
            <span class="text-green">Promocode</span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {

};
</script>

<style lang="scss">
// @import 'src/assets/theme/default/components/styles-loaders';
.ts-loader {
  &__controls-wrapper {
    display: flex;
  }

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  @media (max-width: 650px) {
    &__controls-wrapper {
      display: block;
      .btn-primary{
        width: 100%;
        margin-bottom: 10px;
        margin-top: 10px;
      }
    }

    &__header {
      border-bottom: 1px solid #e7ecf1;
      padding-bottom: 16px;
      display: block;
    }
  }
}
</style>
